import styled, { css } from 'styled-components';
import { Colors, Typography, Dropdown, Input } from '@inplayer-org/inplayer-ui';
import { darken, transparentize } from 'polished';
import { FaRegEdit } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';

// utils
import media from 'utils/mediaQueries';

interface WrapperProps {
  isGrid?: boolean;
  isBorderBottom?: boolean;
  isFlex?: boolean;
}
export const Wrapper = styled.div<WrapperProps>`
  ${({ isGrid }) =>
    isGrid &&
    css`
      display: grid;
      grid-template-columns: 1fr 1fr;

      ${media.customMaxWidth(1500)} {
        grid-template-columns: 1fr;
      }
    `}

  margin: 0.3rem 2rem 1rem;
  padding-bottom: 1rem;
  display: ${({ isFlex }) => isFlex && 'flex'};
  border-bottom: ${({ isBorderBottom }) => isBorderBottom && `1px solid ${Colors.gray}`};
`;

export const ElementWrapper = styled.div<{ margin?: string; flex?: boolean }>`
  margin: ${({ margin }) => margin || '0.5rem 0'};
  display: ${({ flex }) => flex && 'flex'};

  ${media.customMaxWidth(1500)} {
    margin: ${({ margin }) => margin || '1rem 0'};
  }
`;
export const ColoredTypography = styled(Typography)<{ color?: string }>`
  color: ${({ color }) => color};
`;

export const StyledTypography = styled(ColoredTypography)`
  margin-left: 2rem;
`;

export const AddNewTypography = styled(ColoredTypography)`
  font-weight: ${({ theme }) => theme.font.weights.bold};
  margin-left: 0.2rem;
  cursor: pointer;

  :hover {
    color: ${({ color }) => darken(0.1, `${color}`)} !important;
  }
`;
export interface FlexWrapperProps {
  isCenter?: boolean;
  isSpaceBetween?: boolean;
  margin?: string;
}
export const FlexWrapper = styled.div<FlexWrapperProps>`
  display: flex;
  margin: ${({ margin }) => margin};
  align-items: ${({ isCenter }) => isCenter && 'center'};
  justify-content: ${({ isSpaceBetween }) => isSpaceBetween && 'space-between'};
`;
export interface StyledIconProps {
  color?: string;
  width?: string;
  height?: string;
  margin?: string;
}
export const StyledIcon = styled(FaRegEdit)<StyledIconProps>`
  cursor: ${({ color }) => color === `${Colors.blue}` && 'pointer'};
  color: ${({ color }) => color || Colors.fontDarkGray};
  width: ${({ width }) => width || '1.4rem'};
  height: ${({ height }) => height || '1.4rem'};
  margin-left: 0.4rem;
  margin: ${({ margin }) => margin};

  :hover {
    color: ${({ color }) => color === `${Colors.blue}` && darken(0.1, `${color}`)} !important;
  }
`;

export const FooterLinkContainer = styled.div`
  border-radius: 5px;
  background: ${Colors.clouds};
  margin: 1rem 0;
  padding: 0.5rem;
  color: ${Colors.white};
`;

export const StyledDiv = styled.div`
  width: 90%;
`;
export const StyledDropdown = styled(Dropdown)<{ width?: string }>`
  width: ${({ width }) => width || '50%'};
`;

export const StyledInput = styled(Input)<{ width?: string }>`
  width: ${({ width }) => width || '50%'};
`;

export const Container = styled.div`
  margin: 1.5rem;
  margin-left: 4rem;
`;
export const FlexContainer = styled.div`
  display: flex;
`;
export const LayoutWrapper = styled.div`
  width: 42%;
  background: ${Colors.white};
  border-radius: 5px;
  margin-top: 2.5rem;
  box-shadow: 0 0 8px 1px ${transparentize(0.87, Colors.fontDarkGray)};

  @media (max-width: 1820px) and (min-width: 1620px) {
    width: 50%;
  }
  @media (max-width: 1620px) and (min-width: 1500px) {
    width: 60%;
  }
`;
export const TitleContainer = styled.div`
  padding: 0 1.5rem 1.5rem;
  display: flex;
  justify-content: center;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0 1rem 1rem;
`;

type NavLinkProps = {
  hasMargin?: boolean;
};

export const StyledNavLink = styled(NavLink)<NavLinkProps>`
  color: ${Colors.fontGray};

  :hover {
    color: ${Colors.skyBlue};
  }

  ${({ hasMargin }) => (hasMargin ? `margin: 1.5rem 4rem; display: inline-block;` : '')}
`;

export const LoaderWrapper = styled.div`
  margin: 10% 0 0 50%;
`;

export const Overlay = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
`;
export const OAuthWrapper = styled.div`
  margin-left: 2rem;
`;

export const OAuthTypography = styled(Typography)`
  color: ${Colors.darkBlue};
`;
